import { GetVehicleInspectionEligibilityResponse } from '@clearcover/core-app-types';
import { useNewApi } from '../makeApiHttp';
import { AxiosError } from 'axios';

export const useVehicleInspectionEligibility = ({
  policyId,
}: {
  policyId: string;
}): {
  data: GetVehicleInspectionEligibilityResponse | undefined;
  loading: boolean;
  error: AxiosError<any, any> | undefined;
  refetch: () => void;
} => {
  const [{ data, loading, error, refetch }] =
    useNewApi<GetVehicleInspectionEligibilityResponse>(
      {
        url: `/vehicleInspection/${policyId}/eligibility`,
      },
      false,
      false
    );

  return { data, loading, error, refetch };
};
